import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';
import * as CommonFunction from './../../../../../src/app/services/common.function';
import { UserCreate, UserEdit } from '../../../models/manage-user/usercreate.model';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  loCurrentUserData: any;
  private subjectName = new Subject<any>();

  constructor(private http: HttpClient)
  {
    this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
  }

  sendUpdate(obj: any) {
    this.subjectName.next(obj);
   }

   getUpdate(): Observable<any> {
    var obj = this.subjectName.asObservable();
    return obj;
   }

  userCreate(requestUserCreate: any): Observable<any> {
    this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
    const headers = {
      'Authorization': 'Bearer ' + this.loCurrentUserData.accessToken,
      'IgnoreInterceptor': ''
    }
    const body: UserCreate = {
      authToken: this.loCurrentUserData.accessToken,
      phoneNumber: requestUserCreate.phoneNumber,
      emailAddress: requestUserCreate.emailAddress,
      stName: requestUserCreate.stName,
      uiClientId: requestUserCreate.uiClientId,
      stTeamId: requestUserCreate.stTeamId?.toString(),
      colorCode: requestUserCreate.colorCode,
      uiRoleId: requestUserCreate.uiRoleId,
      apiAccessToken : requestUserCreate.apiAccessToken,
      UserCreationType : requestUserCreate.UserCreationType,
      Password : requestUserCreate.Passward,
      uiCreatedBy : requestUserCreate.uiCreatedBy,
      CompanyName : '',
      inRegistrationType: requestUserCreate.inRegistrationType,
      isActive : JSON.parse(requestUserCreate.status),
      isVisibleWebPage : JSON.parse(requestUserCreate.isVisibleWebPage),
      flgIsPreview: requestUserCreate.flgIsPreview || false
    }
    return this.http.post(environment.WebApiURL + 'api/User/Create', body, { headers }).pipe(map((response: any) => {
      return response
    }));
  }

  getRoles(): Observable<any> {
    return this.http.get(environment.WebApiURL + 'api/User/GetRoles').pipe(map((response: any) => {
      return response.data
    }));
  }

  GetClientTeamByClientId(uiClientId: any): Observable<any> {
    //const loFormdata: FormData = new FormData();
    //loFormdata.append('uiClientId', requestGetClientTeamByClientId.uiClientId);
    return this.http.get(environment.WebApiURL + 'api/User/GetClientTeamByClientId?uiClientId=' + uiClientId).pipe(map((response: any) => {
      return response.data
    }));
  }

  GetUserTeamByUserId(uiUserId: any): Observable<any> {
    //const loFormdata: FormData = new FormData();
    //loFormdata.append('uiClientId', requestGetClientTeamByClientId.uiClientId);
    return this.http.get(environment.WebApiURL + 'api/User/GetUserTeamByUserId?uiUserId=' + uiUserId).pipe(map((response: any) => {
      return response.data
    }));
  }

  getclientproductbyclientid(uiClientId: any): Observable<any> {
    // const loFormdata: FormData = new FormData();
    // loFormdata.append('ClientId', requestGetClientProductByClientId.ClientId);
    return this.http.get(environment.WebApiURL + 'api/User/GetClientProductByClientId?ClientId=' + uiClientId +"&TimeZone=" +  CommonFunction.GetTimeZone()).pipe(map((response: any) => {
      return response.data
    }));
  }

  getUsers(body: any): Observable<any> {
    return this.http.post(environment.WebApiURL + 'api/User/GetUsers', body).pipe(map((response: any) => {
      return response
    }));
  }

  getUserById(userId: any): Observable<any> {
    // const loFormdata: FormData = new FormData();
    // loFormdata.append('ClientId', requestGetClientProductByClientId.ClientId);
    return this.http.get(environment.WebApiURL + 'api/User/GetUserById?uiUserId=' + userId).pipe(map((response: any) => {
      return response.data
    }));
  }

   getUserByIdForTwoFA(userId: any): Observable<any> {
    return this.http.get(environment.WebApiURL + 'api/User/GetUserByIdForTwoFA?uiUserId=' + userId).pipe(map((response: any) => {
      return response.data
    }));
  }

  userUpdate(requestUserUpdate: any, userId: any): Observable<any> {
    this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
    const headers = {
      'Authorization': 'Bearer ' + this.loCurrentUserData.accessToken,
      'IgnoreInterceptor': ''
    }
     
    const body: UserEdit = {
      authToken: this.loCurrentUserData.accessToken,
      phoneNumber: requestUserUpdate.phoneNumber,
      emailAddress: requestUserUpdate.emailAddress,
      stName: requestUserUpdate.stName,
      uiClientId: requestUserUpdate.uiClientId,
      stTeamId: requestUserUpdate.stTeamId,
      stcolorCode: requestUserUpdate.stcolorCode,
      uiRoleId: requestUserUpdate.uiRoleId,
      uiUserId: userId,
      apiAccessToken : requestUserUpdate.apiAccessToken,
      uiUpdatedBy:requestUserUpdate.uiUpdatedBy,
      flgIsPreview: requestUserUpdate.flgIsPreview || false,
      isActive: JSON.parse(requestUserUpdate.status),
      isVisibleWebPage: JSON.parse(requestUserUpdate.isVisibleWebPage),
    }
    return this.http.post(environment.WebApiURL + 'api/User/Edit', body, { headers }).pipe(map((response: any) => {
      return response
    }));
  }

  archiveUser(userId: any): Observable<any> {
    const body = {
      uiUserId: userId
    }
    return this.http.post(environment.WebApiURL + 'api/User/ArchiveUser', body).pipe(map((response: any) => {
      return response
    }));
  }

  unLockUserAccount(userId: any): Observable<any> {
    const body = {
      uiUserId: userId
    }
    return this.http.post(environment.WebApiURL + 'api/User/unLockUserAccount', body).pipe(map((response: any) => {
      return response
    }));
  }

  updateUserStatus(clientId: any, userId: any, stClient:any, inStatus: any): Observable<any> {
    const body = {
      uiClientId: clientId,
      uiUserId: userId,
      stClientName: stClient,
      inStatus: inStatus,
      TimeZone: CommonFunction.GetTimeZone()
    }
    return this.http.post(environment.WebApiURL + 'api/User/updateUserStatus', body).pipe(map((response: any) => {
      return response
    }));
  }

  GenerateAPIAccessToken(uiUserId: any, uiClientId: any): Observable<any> {
    return this.http.get(environment.WebApiURL + 'api/User/GenerateAPIAccessToken?uiUserId=' + uiUserId + '&uiClientId=' + uiClientId).pipe(map((response: any) => {
      return response
    }));
  }

  revoke2FA(revokeUserId: any): Observable<any> {
    const userId = {
      uiUserId : revokeUserId
    }

    return this.http.post(environment.WebApiURL + 'api/User/RevokeUser2FA', userId).pipe(map((response: any) => {
      return response
    }));
  }
}